<template>
  <div>
    <!-- Solicitar cotizacion con sesion activa -->
    <v-dialog v-model="dialog" persistent max-width="900px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dense v-on="on"> Solicitar cotización </v-btn>
      </template>

      <!-- Registro -->
      <v-card v-if="session">
        <v-card-title>
          <span class="headline">Solicitar cotización Sesion</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-textarea label="Comentarios" v-model="comment"></v-textarea>
              </v-col>
            </v-row>
          </v-container>

          <small>*indicates required field</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="blue darken-1" text @click="makeQuotation(isClient)">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Registro -->
      <v-card v-if="!session">
        <v-card-title>
          <span class="headline">Solicitar cotización No sesion</span>
        </v-card-title>

        <v-card-text>
          <login></login>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="blue darken-1" text @click="dialog = false">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
var _ = require("underscore");
import login from "./../../views/user-views/login.vue";
import register from "./../../views/user-views/register.vue";

export default {
  components: {
    login,
    register,
  },

  data() {
    return {
      comment: "",
      dialog: false,
      isClient: false,
    };
  },

  props: {
    updateShopingQuantity: { type: Function },
    products: { type: Array },
    session: { type: Boolean },
    snackbar: { type: Function },
  },

  methods: {
    makeQuotation: function () {
      var token = localStorage.getItem("token");
      var userId = localStorage.getItem("userId");
      var quotationLines = _.map(this.products, function (product) {
        var line = {
          quantity: product.quantity,
          itemId: product.itemId,
          productId: product.id,
        };
        return line;
      });
      var quotationObject = {
        userId: userId,
        comments: this.comment,
        quotationLines: quotationLines,
      };
      this.$http
        .post("quotation", quotationObject, {
          authorization: `Bearer ${token}`,
        })
        .then(
          (response) => {
            this.snackbar(
              response.body.message || "Cotización creada con éxito"
            );
            localStorage.setItem("shoppingCart", []);
            this.$router.go();
            this.saving = false;
          },
          (error) => {
            var message = error.body.message || "Error al crear Cotización";
            this.snackbar(message);
            this.saving = false;
            console.error(error);
            this.userId = "";
          }
        );

      this.dialog = false;
    },
  },

  computed: {},

  watch: {},

  created: function () {
    this.client = JSON.parse(localStorage.getItem("clientId"));

    this.isClient = !!this.client;
  },

  mounted() {},
};
</script>

<style></style>
